import type { QueryClient } from "@tanstack/react-query";

export async function clearUserCache(queryClient: QueryClient): Promise<void> {
  // Cancel before clearing so late responses cannot populate the next user's cache.
  await queryClient.cancelQueries();
  queryClient.clear();
  window.dispatchEvent(new Event("whaleseek:clear-session-cache"));
  try {
    localStorage.removeItem("ws_query_cache");
    if ("caches" in window) {
      const names = await caches.keys();
      await Promise.all(names.filter(name => name.startsWith("whaleseek-api-")).map(name => caches.delete(name)));
    }
  } catch {
    // Private browsing may deny storage; authentication must still work.
  }
}
